var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_158_1066)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.80957,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFD90E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3552 61.3796C48.6152 61.3796 47.1152 61.0496 45.8552 60.3896C44.5952 59.7096 43.6252 58.7996 42.9452 57.6596C42.2852 56.5196 41.9552 55.2596 41.9552 53.8796H46.6952C46.6952 54.5596 46.8452 55.1596 47.1452 55.6796C47.4652 56.1796 47.9052 56.5796 48.4652 56.8796C49.0252 57.1596 49.6652 57.2996 50.3852 57.2996C51.1852 57.2996 51.8552 57.1396 52.3952 56.8196C52.9552 56.4796 53.3852 56.0296 53.6852 55.4696C53.9852 54.8896 54.1352 54.2396 54.1352 53.5196C54.1352 52.7796 53.9852 52.1296 53.6852 51.5696C53.4052 50.9896 52.9852 50.5296 52.4252 50.1896C51.8852 49.8496 51.2252 49.6796 50.4452 49.6796C49.7252 49.6796 49.0752 49.8296 48.4952 50.1296C47.9152 50.4296 47.4852 50.8096 47.2052 51.2696H42.5852L43.6952 38.9096H56.9852V43.1096H45.6452L47.5352 41.8496L46.8752 48.9596L45.7352 48.6596C46.3352 47.9396 47.0552 47.3396 47.8952 46.8596C48.7552 46.3596 49.8752 46.1096 51.2552 46.1096C52.8552 46.1096 54.2152 46.4396 55.3352 47.0996C56.4752 47.7396 57.3452 48.6096 57.9452 49.7096C58.5652 50.7896 58.8752 51.9996 58.8752 53.3396V53.7296C58.8752 55.0696 58.5452 56.3196 57.8852 57.4796C57.2252 58.6396 56.2552 59.5796 54.9752 60.2996C53.7152 61.0196 52.1752 61.3796 50.3552 61.3796Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_158_1066",
    x: 0.228516,
    y: 0.80957,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_1066"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.6f48c2c0db382f19310865f6f59c7f78.svg";
export { ForwardRef as ReactComponent };